<template>
  <ImageUpload
    v-model="mediaURL"
    :label="label"
    :width="width"
    :height="height"
    :help="recommendedSizeDim()"
    :disabled="isTournamentFieldDisabled(prop)"
    :tooltip="tooltip"
    class="tournament-promotion-image-input-wrapper"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { translate } from '@/mixins/translate';
import ImageUpload from '@/components/form/ImageUpload';
export default {
  name: 'TournamentMediaUploadInput',
  components: {
    ImageUpload,
  },
  mixins: [translate('_web_tournament_settings')],
  props: {
    prop: {
      required: true,
      type: String,
    },
    section: {
      required: true,
      type: String,
    },
    tooltip: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 1,
    },
    height: {
      type: Number,
      default: 1,
    },
    recommendedWidth: {
      type: Number,
      default: 512,
    },
    recommendedHeight: {
      type: Number,
      default: 512,
    },
  },
  computed: {
    ...mapGetters([
      'currentTournament',
      'isTournamentFieldDisabled',
      'currentTournamentImages',
      'getGamePropById',
    ]),
    mediaURL: {
      get() {
        return (
          this.$lodash.get(
            this.currentTournamentImages,
            `${this.prop}.objectURL`,
            ''
          ) ||
          this.$lodash.get(
            this.currentTournamentImages,
            `${this.prop}.display_uri`,
            ''
          ) ||
          this.$lodash.get(this.currentTournamentImages, this.prop, null) ||
          this.getGamePropById(
            this.$lodash.get(this.currentTournament, 'info.game', ''),
            this.prop
          )
        );
      },
      set(data) {
        this.onImgUploaded(data);
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    recommendedSizeDim() {
      return this.$$t(
        '{width}×{height}px',
        'image-recommended-size-dimensions',
        { width: this.recommendedWidth, height: this.recommendedHeight }
      );
    },
    onImgUploaded(fileInfo) {
      this.updateCurrentTournament({
        [this.prop]: fileInfo,
        component: this.section,
      });
    },
  },
};
</script>

<style lang="scss">
.tournament-promotion-image-input-wrapper {
  .embed-responsive {
    max-height: 220px;
  }
}
</style>
